import { render, staticRenderFns } from "./disabledProducts.vue?vue&type=template&id=652ad13e&scoped=true&"
import script from "./disabledProducts.vue?vue&type=script&lang=js&"
export * from "./disabledProducts.vue?vue&type=script&lang=js&"
import style0 from "./disabledProducts.vue?vue&type=style&index=0&id=652ad13e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652ad13e",
  null
  
)

export default component.exports